import * as React from "react";
import Enlarge from "./enlarge";
import FieldDrawer from "../fieldDrawer";
import {
  IFieldDrawer,
  IEnlargeCommonProps
} from "../../utils/interface/smallTools";
import { PositionProperty } from "csstype";
import "./smallTools.less";

//import cuid from "cuid";

interface ISmallToolsProps {
  content?: React.ReactNode;
  isOpenEnlarge?: boolean;
  isOpenFieldDrawer?: boolean;
  fieldDrawer?: IFieldDrawer;
  enlargeProps?: IEnlargeCommonProps;
  // 覆盖默认样式
  overwriteDefaultStyle?: any;
  // 唯一标识
  cuid?: any;
  display?: any;
}

class SmallTools extends React.Component<ISmallToolsProps, any> {
  cuid: any;
  state = {
    containerStyle: {
      position: "relative" as PositionProperty,
      marginBottom: 30
    },
    toolsStyle: {
      position: "absolute" as PositionProperty,
      display: "flex",
      flexFlow: "row",
      color: "#1890ff",
      top: -16,
      right: 0,
      cursor: "pointer"
    }
  };

  constructor(props: ISmallToolsProps) {
    super(props);
    this.cuid = this.props.cuid || "2222";
  }

  onEnlargeClick = (enlarge: boolean) => {
    if (enlarge) {
      this.setState({
        containerStyle: {
          position: "fixed" as PositionProperty,
          top: 0,
          left: 0,
          padding: "40px 40px",
          backgroundColor: "white",
          width: "100%",
          height: "100%",
          zIndex: 10,
          overflow: "auto"
        },
        toolsStyle: {
          position: "absolute" as PositionProperty,
          display: "flex",
          flexFlow: "row",
          color: "#1890ff",
          top: 10,
          right: 40,
          cursor: "pointer"
        }
      });
    } else {
      this.setState({
        containerStyle: {
          position: "relative" as PositionProperty,
        },
        toolsStyle: {
          position: "absolute" as PositionProperty,
          display: "flex",
          flexFlow: "row",
          color: "#1890ff",
          top: -16,
          right: 0,
          cursor: "pointer"
        }
      });
    }
  };



  initTools = () => {
    let tools: any = [];

    if (this.props.isOpenEnlarge) {
      tools.push(
        <Enlarge
          key={"enlarge"}
          {...this.props.enlargeProps}
          onClick={this.onEnlargeClick}
        />
      );
    }

    if (this.props.isOpenFieldDrawer) {
      tools.push(<FieldDrawer key="fieldDrawer" {...this.props.fieldDrawer} />);
    }
    return tools;
  };

  // initToolStyle = () => {
  //   return {
  //     position: "absolute" as PositionProperty,
  //     display: "flex",
  //     flexFlow: "row",
  //     color: "#1890ff",
  //     top: -16,
  //     right: 0,
  //     cursor: "pointer"
  //   };
  // };

  render() {
    let containerStyle = this.state.containerStyle,
      toolsStyle = this.state.toolsStyle;

    if (this.props.overwriteDefaultStyle) {
      if (this.props.overwriteDefaultStyle.containerStyle) {
        containerStyle = this.props.overwriteDefaultStyle.containerStyle;
      }

      if (this.props.overwriteDefaultStyle.toolsStyle) {
        toolsStyle = this.props.overwriteDefaultStyle.toolsStyle;
      }
    }
    //console.log(containerStyle);
    return (
      <React.Fragment>
        <div style={containerStyle} data-cuid={this.cuid}>
          <div className="small-tools" style={toolsStyle}>
            {this.initTools()}
          </div>
          {this.props.content}
        </div>
      </React.Fragment>
    );
  }
}

export default SmallTools;
